import React from "react";
import { Camera } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

/** "Photographer of the Atlas" pill: author of the most-liked photo/video this month. */
export default function PhotographerBadge({ show, className = "" }) {
  const { t } = useLang();
  if (!show) return null;
  return (
    <span title={t("photographer_badge_hint")} data-testid="photographer-badge"
      className={`inline-flex items-center gap-1 rounded-full bg-ochre text-white text-[10px] font-semibold px-2 py-0.5 leading-tight whitespace-nowrap shrink-0 ${className}`}>
      <Camera className="w-3 h-3" /> {t("photographer_badge")}
    </span>
  );
}
